import React, { useContext } from "react";
import { logoNVIGOnly } from "../../assets/assetsExport";
import { useSelector } from "react-redux";
import { getLang } from "../../features/app/appSlice";
import { IconRight } from "../../assets/svgExport";
import { NavLink } from "react-router-dom";

export default function ContactUsBanner() {
  const lang = useSelector(getLang);

  return (
    <div className="relative bg-secondary-dark text-white overflow-hidden">
      <div className="content-container py-16 sm:py-24 relative z-10">
        <p className="font-poster text-4xl sm:text-5xl border-b border-white/15 pb-6 sm:pb-8 mb-8 sm:mb-10 inline-flex flex-col gap-2 md-lg:gap-0 md-lg:flex-row leading-tight">
          {lang ? (
            <>
              <span>Get in Touch&nbsp;</span>
              <span>with Our Team</span>
            </>
          ) : (
            <span className="text-3xl sm:text-4xl">与我们的团队联系</span>
          )}
        </p>
        <NavLink
          to="/contact"
          className="group inline-flex gap-3 items-center"
        >
          <div className="inline-flex items-center justify-center bg-white rounded-full p-1.5 group-hover:bg-main group-hover:scale-105 transition-all duration-300">
            <IconRight width={14} height={14} />
          </div>
          <span className="text-white text-sm font-medium tracking-[0.2em] uppercase">
            {lang ? "Contact Us" : "联系我们"}
          </span>
        </NavLink>
      </div>
      <img
        className="absolute w-[200px] sm:w-[280px] right-0 bottom-0 opacity-90 pointer-events-none select-none"
        src={logoNVIGOnly}
        alt={lang ? "NVIG's Logo Zoomed in" : "NVIG的标志放大"}
      />
    </div>
  );
}
